import { useState, useEffect, useRef } from 'react';

const Typewriter = ({ id, text, className, delay, pauseDelay, isComplete, setIsComplete }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentId, setCurrentId] = useState(id);
    let currentText = useRef('');
    
    if (currentId !== id) {
        setCurrentId(id);
        setCurrentIndex(0);
        currentText.current = '';
    }

    useEffect(() => {
        if (currentIndex <= text.length) {
            if (isComplete && setIsComplete) {
                setIsComplete(false);
            }

            const delayMin = 1;
            const delayMax = delay || 10;
            delay = Math.floor(Math.random() * (delayMax - delayMin + 1)) + delayMin;
            pauseDelay = pauseDelay || 600;

            let doPause = false;
            let curChar = text[currentIndex];
            switch (curChar) {
                case 'Å':
                    curChar = '<i class="bi-house-door-fill a8-orange" style="font-size: 1.3em;"></i>';
                    break;
                case '¤':
                    curChar = '<i class="bi-journal-text a8-orange" style="font-size: 1.3em;"></i>';
                    break;
                case '¿':
                    curChar = '<i class="bi-question-circle a8-orange" style="font-size: 1.3em;"></i>';
                    break;
                case '~':
                    curChar = '<br />';
                    break;
                case '_':
                    curChar = '&nbsp;';
                    break;
                case '*':
                    curChar = '&#x2022;';
                    break;
                case '^':
                    curChar = '';
                    doPause = true;
                    break;
            }

            const timeout = setTimeout(() => {
                setCurrentIndex(currentIndex + 1);
                
                if (curChar !== undefined) {
                    currentText.current += curChar;
                }
            }, doPause ? pauseDelay : delay);

            return () => clearTimeout(timeout);
        } else if (!isComplete && setIsComplete) {
            setIsComplete(true);
        }
    }, [currentIndex]);

    return <span id={id} className={className} dangerouslySetInnerHTML={{__html:currentText.current}} />;
};

export default Typewriter;